import { useStoreRequired } from 'features/store/hooks/use-store-required';
import { View } from 'react-native';

import { FloatingViewCartFab } from 'components/floating-view-cart-fab';
import { useAcceleratorBadgesOnMenuExperiment } from 'experiments/use-accelerator-badges-on-menu-experiment';
import { useEnableUnifiedMenu } from 'hooks/use-enable-unified-menu';
import { MenuSection } from 'pages/menu/menu-object-page/menu-section';
import { MenuSection as MenuSectionBadgesExperiment } from 'pages/menu/menu-object-page/menu-section/menu-section-badges-experiment';
import { MenuSectionPage } from 'pages/menu/menu-section-page/menu-section-page';

export default function MenuSectionPageById() {
  useStoreRequired();

  const enableUnifiedMenu = useEnableUnifiedMenu();
  const enableMenuAcceratorBadgesExperiment = useAcceleratorBadgesOnMenuExperiment(true);

  return (
    <View testID="menu-section-page" style={{ flex: 1 }}>
      {enableUnifiedMenu ? (
        <MenuSectionPage />
      ) : enableMenuAcceratorBadgesExperiment ? (
        <MenuSectionBadgesExperiment />
      ) : (
        <MenuSection />
      )}
      <FloatingViewCartFab />
    </View>
  );
}
